import * as userTokenRequests from "../../api/userTokenRequest";
import {START_LOAD, FINISH_LOAD} from "../reducers/all_teams";
import {push} from "./message";


const startLoading = () => {
    return {type: START_LOAD};
};
const finishLoading = (all_teams) => {
    return {type: FINISH_LOAD, payload: all_teams};
};


export const getTeamsByEventId = (id) => {
    return dispatch => {
        dispatch(startLoading());
        userTokenRequests.getTeamsByEventId(id)
            .then(all_teams => {
                dispatch(finishLoading(all_teams))
            })
            .catch(error => {
                dispatch(finishLoading(null));
                dispatch(push(error.message))
            })
    }
};
